import React from 'react';
import clsx from 'clsx';
import { Trans, useTranslation } from 'react-i18next';

import { useCheckoutCurrency } from 'hooks/context/checkoutSession';
import { useCalcContext } from 'hooks/context/calc';
import { useGiftCards } from 'hooks/context/giftcards';

import { fromCentsWithLocale } from 'utils/Currency';
import { getGiftCardDeductions } from 'utils/GiftCards';

import { DEDUCTIONS_GIFT_CARD_TEST_ID } from './const';

import styles from '../styles.module.scss';

export const Deductions = () => {
  const { t } = useTranslation();
  const currency = useCheckoutCurrency();
  const { payableTotalAmount, convenienceFee = 0, tipAmount = 0 } = useCalcContext();
  const { giftCards } = useGiftCards();

  // we include tax, tip and convFee to compute actual total for proper gift card balance check
  const renderGiftCardDeductions = (payableTotalAmount: number, convFee: number, tip: number) => {
    const deductions = getGiftCardDeductions(payableTotalAmount + convFee + tip, giftCards);
    if (!deductions?.length) return null;

    return deductions.map(({ token, last4, amountUsedFromGiftCard }) => (
      <p key={token} data-testid={DEDUCTIONS_GIFT_CARD_TEST_ID}>
        <Trans i18nKey="giftCardWithAmount">
          <span>Gift card {{last4}}</span>
          <span className={clsx([styles.amount, styles.deductionAmounts])}>
              {{ giftCard: t('money', { amount: fromCentsWithLocale((amountUsedFromGiftCard || 0) * -1, currency) }) }}
            </span>
        </Trans>
      </p>
    ));
  }

  return (
    <>
      {renderGiftCardDeductions(payableTotalAmount, convenienceFee, tipAmount)}
    </>
  );
}
